import StoreBanner from './StoreBanner';
export default StoreBanner;
